<template>
  <div class="OnlineBiddingRoom">
    <el-dialog
      :visible.sync="blackListShow3"
      title="供应商等级异常提醒"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p>系统检测到您的供应商等级暂不符合我司在线竞价活动参与要求。如需升级等级，请联系我司项目对接人。</p>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="show"
      title="CA盖章环境监测异常"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p style="font-size: medium; padding-bottom: 15px">系统监测到您当前电脑的CA盖章环境异常，将无法完成报价，请按照如下步骤指引操作：</p>
        <p style="font-size: medium; padding-bottom: 15px">
          （1）、在浏览器地址栏输入：chrome://flags/#local-network-access-check，将“Local Network Access Check”设置为“Disabled”后重启浏览器
        </p>
        <p style="font-size: medium; padding-bottom: 15px">（2）、点击下面按钮下载CA环境安装包，在电脑上重新安装CA盖章软件。</p>
        <p style="font-size: medium; padding-bottom: 15px">完成上述操作后重启浏览器在进入报价页面。</p>

        <div style="padding-top: 1rem; text-align: center">
          <el-button class="apply_btn" type="primary" @click="downloadTemplate()"> 下载CA环境安装包</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="show2"
      title="CA盖章环境监测异常"
      width="700px"
      class="dialog-wrap form-module"
      :close-on-press-escape="false"
      :show-close="true"
      :center="true"
      :close-on-click-modal="false"
    >
      <div style="padding-left: 0.625rem; padding-top: 0.9375rem" class="warn_content">
        <p style="font-size: medium; padding-bottom: 15px">系统检测到您当前使用的浏览器不是“谷歌浏览器”或者浏览器版本过低，可能会导致报价失败；</p>
        <p style="font-size: medium; padding-bottom: 15px">
          请前往谷歌浏览器官网<a href="https://www.google.cn/chrome/" target="_blank">https://www.google.cn/chrome/</a>
          获取最新版本的谷歌浏览器后重试！
        </p>
      </div>
    </el-dialog>
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>
          <router-link to="/MemberCenter">在线竞价</router-link>
        </el-breadcrumb-item>
        <el-breadcrumb-item>{{ ProjectName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="right_content">
      <div class="title1" v-if="IsStart">
        倒计时：<b>{{ day }}</b
        >天<b>{{ hr }}</b> 小时 <b>{{ min }}</b> 分 <b>{{ sec }}</b> 秒
      </div>
      <div class="title1" v-else>竞价未开始</div>
      <div class="title2">项目基本信息</div>
      <div class="list_wrap1">
        <div class="list"><span class="text1">项目名称：</span>{{ schemeData.ProjectName }}</div>
        <div class="list"></div>
        <div class="list"><span class="text1">采购编号：</span>{{ schemeData.SchemeCode }}</div>
        <div class="list"><span class="text1">商务联系人：</span>{{ schemeData.ContactName }}</div>
        <div class="list"><span class="text1">商务联系人电话：</span>{{ schemeData.ContactTelephone }}</div>
        <div class="list"><span class="text1">商务联系人邮箱：</span>{{ schemeData.ContactEmail }}</div>
        <div class="list"><span class="text1">技术联系人</span>{{ schemeData.TechnicalContact }}</div>
        <div class="list"><span class="text1">技术联系人电话：</span>{{ schemeData.TechnicalContactPhone }}</div>
        <div class="list"><span class="text1">技术联系人邮箱：</span>{{ schemeData.TechnicalContactEmail }}</div>
        <div class="list"><span class="text1">报价开始时间：</span>{{ schemeData.EvaluationBeginTime }}</div>
        <div class="list"><span class="text1">报价结束时间：</span>{{ schemeData.EvaluationEndTime }}</div>
        <div class="list"></div>
        <div class="list_row"><span class="text1">报价注意事项：</span>{{ schemeData.Remark }}</div>
      </div>

      <div class="title2" style="margin-top: 15px">我的竞价详情</div>
      <div class="list_wrap2">
        <div class="list">
          <img class="img1" src="../../assets/img/icon_Rank.png" />
          <div class="right_text">
            <div>
              <div>当前排名</div>
              <div class="text_num">{{ supplierQuote.Rank }}</div>
            </div>
          </div>
        </div>
        <div class="list">
          <img class="img1" src="../../assets/img/icon_Price.png" />
          <div class="right_text">
            <div class="text1">
              <div>当前出价</div>
              <div class="text_num">{{ supplierQuote.TotalTenderAmount }}</div>
            </div>
            <div class="text2">
              <el-button type="primary" class="btn" @click="fnEditQuote()" v-if="IsStart">我要报价</el-button>
              <div class="text_warning" v-if="supplierQuote.IsQuote"><i class="el-icon-warning"></i>报价未提交，请注意</div>
            </div>
          </div>
        </div>
      </div>

      <el-tabs v-model="activeName" @tab-click="handleClick1" class="el_tabs">
        <el-tab-pane label="报价清单" name="first">
          <el-table :data="schemeProjectList" class="el_table" border>
            <el-table-column prop="Index" label="序号">
              <template slot-scope="scope">
                {{ scope.$index + 1 }}
              </template>
            </el-table-column>
            <el-table-column prop="InstrumentName" label="设备名称"></el-table-column>
            <el-table-column prop="PlanCode" label="计划编号"></el-table-column>
            <!-- <el-table-column prop="Specification" label="设备型号"></el-table-column> -->
            <el-table-column prop="file" label="技术参数">
              <template slot-scope="scope">
                <el-link @click="fnReadPdf(scope.row.fileId, scope.row.fileId1)" :underline="false" style="color: #0361b1"> 预览</el-link>
              </template>
            </el-table-column>
            <el-table-column prop="file" label="更新的技术参数">
              <template slot-scope="scope">
                <el-link
                  v-if="scope.row.fileId2 != ''"
                  @click="fnReadPdf(scope.row.fileId2, scope.row.fileId1)"
                  :underline="false"
                  style="color: #0361b1"
                >
                  预览</el-link
                >
                <span v-else>无更新</span>
              </template>
            </el-table-column>
            <el-table-column prop="Count" label="数量"></el-table-column>
            <el-table-column prop="Unit" label="单位"></el-table-column>
            <!-- <el-table-column prop="Price" label="当前报价"></el-table-column> -->
            <el-table-column prop="Trademark" label="需求品牌"></el-table-column>
            <el-table-column prop="Specification" label="需求型号"></el-table-column>
            <el-table-column prop="ReceivingCompanyCode" label="收货地址"></el-table-column>
            <el-table-column prop="FixedPrice" label="限价（元）"></el-table-column>
            <el-table-column prop="SettlementMethodName" label="结算方式"></el-table-column>
            <el-table-column prop="PaymentRatio" label="付款比例" align="center" width="600px">
              <template slot-scope="scope">
                <div v-for="(item, index) in scope.row.PaymentRatio" :key="index">{{ item }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="DeliveryTime" label="货期要求" width="250px">
              <template slot-scope="scope"> 自合同签订之日起{{ scope.row.DeliveryTime }}个自然日 </template>
            </el-table-column>
            <el-table-column prop="TestCycle" label="安装调试要求" width="250px">
              <template slot-scope="scope"> 乙方负责在到货后{{ scope.row.TestCycle }}个自然日内完成货物的安装调试 </template>
            </el-table-column>
            <el-table-column prop="WarrantyRequirement" label="保修要求" width="250px">
              <template slot-scope="scope"> 自甲方内部验收之日起{{ scope.row.WarrantyRequirement }}个自然年 </template>
            </el-table-column>
            <el-table-column prop="TraceabilityRequirement" label="溯源要求"></el-table-column>
            <el-table-column prop="TraceabilityUnit" label="溯源机构"></el-table-column>
            <el-table-column prop="OthersRequirement" label="其他要求"></el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="竞价记录" name="second">
          <div class="main_content">
            <div class="left_Wrap">
              <el-tabs :tab-position="'left'" @tab-click="handleClick2" class="el_tabs2">
                <el-tab-pane label="" v-for="(item, index) in operateList" :key="index">
                  <div slot="label" class="list_content">
                    <div class="tip">第{{ operateList.length - index }}次</div>
                    <div class="inforight">
                      <div class="list"><span class="text1">出价金额：</span>{{ item.Price }}</div>
                      <div class="list"><span class="text1">当时排名：</span>{{ item.Rank }}</div>
                      <div class="list"><span class="text1">出价时间：</span>{{ item.OperateDate }}</div>
                    </div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
            <div class="right_Wrap">
              <el-table :data="ProjectList" class="el_table" border>
                <el-table-column prop="InstrumentName" label="需求设备名称"></el-table-column>
                <!-- <el-table-column prop="Specification" label="需求设备设备型号"></el-table-column> -->
                <el-table-column prop="SupplierInstrumentName" label="供货设备名称"></el-table-column>
                <el-table-column prop="SupplierSpecification" label="供货设备设备型号"></el-table-column>
                <el-table-column prop="file" label="技术参数">
                  <template slot-scope="scope">
                    <el-link @click="fnReadPdf(scope.row.fileId, scope.row.fileId1)" :underline="false" style="color: #0361b1"> 预览</el-link>
                  </template>
                </el-table-column>
                <el-table-column prop="file" label="更新的技术参数">
                  <template slot-scope="scope">
                    <el-link
                      v-if="scope.row.fileId2 != ''"
                      @click="fnReadPdf(scope.row.fileId2, scope.row.fileId1)"
                      :underline="false"
                      style="color: #0361b1"
                    >
                      预览</el-link
                    >
                    <span v-else>无更新</span>
                  </template>
                </el-table-column>
                <el-table-column prop="Count" label="数量"></el-table-column>
                <el-table-column prop="Unit" label="单位"></el-table-column>
                <el-table-column prop="SchemeDeliveryTime" label="货期要求" width="250px">
                  <template slot-scope="scope"> 自合同签订之日起{{ scope.row.SchemeDeliveryTime }}个自然日 </template>
                </el-table-column>
                <el-table-column prop="SchemeTestCycle" label="安装调试要求" width="250px">
                  <template slot-scope="scope"> 乙方负责在到货后{{ scope.row.SchemeTestCycle }}个自然日内完成货物的安装调试 </template>
                </el-table-column>
                <el-table-column prop="SchemeWarrantyRequirement" label="保修要求" width="250px">
                  <template slot-scope="scope"> 自甲方内部验收之日起{{ scope.row.SchemeWarrantyRequirement }}个自然年 </template>
                </el-table-column>
                <el-table-column prop="Price" label="当前报价">
                  <template slot-scope="scope">
                    {{ parseFloat(parseFloat(scope.row.Price) * parseFloat(scope.row.Count)).toFixed(2) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getNativeChromeInfo } from '@/assets/js/browser.js'
export default {
  name: 'aboutUs',
  components: {},
  data() {
    return {
      show: false,
      show2: false,
      NowTime: 0,
      day: 0,
      hr: 0,
      min: 0,
      sec: 0,
      ProjectName: this.$route.query.ProjectName,
      SchemeId: this.$route.query.SchemeId,
      activeName: 'first',
      ProjectList: [],
      schemeData: {},
      schemeProjectList: [],
      supplierQuote: [],
      operateList: [],
      IsStart: false,
      interval: '',
      show: false,
      blackListShow3: false
    }
  },
  created: function () {
    setInterval(this.flashPage, 1000 * 60)
  },
  computed: {},
  mounted() {
    this.AddOperateLog()
  },
  methods: {
    flashPage: function () {
      clearInterval(this.interval)
      this.getData()
    },
    handleClick1(tab, evnets) {
      console.log(tab.index)
    },
    handleClick2(tab, evnets) {
      this.ProjectList = this.operateList[tab.index].ProjectList
    },
    AddOperateLog() {
      let config = {
        params: {
          SchemeId: this.SchemeId
        }
      }

      this.getRequest('Purchase/AddSupplierOperateLog', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            localStorage.setItem('OnlineBiddingList', Math.random()) //刷新列表
            this.getData()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getData() {
      let config = {
        params: {
          SchemeId: this.SchemeId
        }
      }

      this.getRequest('Purchase/GetOnlineBiddingData', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.schemeData = res.data.scheme
            this.IsStart = this.schemeData.IsStart
            this.schemeProjectList = res.data.schemeProject
            this.supplierQuote = res.data.supplierQuote
            this.operateList = this.supplierQuote.operateList
            if (this.operateList.length > 0) {
              this.ProjectList = this.operateList[0].ProjectList
            }

            this.NowTime = new Date(this.schemeData.NowTime).getTime()
            this.countdown()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnEditQuote() {
      this.getRequest('SupplierLogin/ValidateBlacklistStatus')
        .then((res) => {
          if (res.data.errcode == 0) {
            // const info = getNativeChromeInfo()

            // if (!info.isChrome || Number(info.version) < 142) {
            //   this.show2 = true
            // } else {
            // 发一个 HEAD 请求试探是否能连通
            fetch('http://127.0.0.1:21051/PDFClient/viewer.html', {
              method: 'GET', // 关键
              mode: 'cors', // 跨域不报错
              cache: 'no-cache'
            })
              .then((res) => {
                console.log(res)
                if (res.statusText == 'OK') {
                  let routerData = this.$router.resolve({
                    name: 'EditOnlineBidding',
                    query: {
                      SchemeId: this.SchemeId,
                      ProjectName: this.ProjectName,
                      IsQuote: this.supplierQuote.IsQuote
                    }
                  })
                  window.open(routerData.href, '_blank')
                  setTimeout(() => {
                    window.close()
                  }, 1000)
                } else {
                  this.show = true
                }
              })
              .catch((err) => {
                console.log(err)
                this.show = true
              })
            // }
          } else if (res.data.errcode == 4) {
            this.blackListShow3 = true
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    checkUrl() {},
    fnReadPdf(fileId, fileId1) {
      let routerData = this.$router.resolve({
        path: 'ReadPDF',
        query: {
          fileId: fileId,
          fileId1: fileId1
        }
      })
      window.open(routerData.href, '_blank')
    },

    countdown() {
      this.interval = setInterval(() => {
        //定义this指向
        const that = this
        that.NowTime = that.NowTime + 1000
        //设置结束时间
        const end = new Date(this.schemeData.EvaluationEndTime).getTime()
        //设置开始时间
        const now = that.NowTime

        // 做判断当倒计时结束时都为0
        if (now >= end) {
          that.day = 0
          that.hr = 0
          that.min = 0
          that.sec = 0
          return
        }
        // 用结束时间减去当前时间获得倒计时时间戳
        const msec = end - now
        let day = parseInt(msec / 1000 / 60 / 60 / 24) //算出天数
        let hr = parseInt((msec / 1000 / 60 / 60) % 24) //算出小时数
        let min = parseInt((msec / 1000 / 60) % 60) //算出分钟数
        let sec = parseInt((msec / 1000) % 60) //算出秒数
        //给数据赋值
        that.day = day
        that.hr = hr > 9 ? hr : '0' + hr
        that.min = min > 9 ? min : '0' + min
        that.sec = sec > 9 ? sec : '0' + sec
      }, 1000)
    },
    downloadTemplate() {
      var templatefilePath = '~/App_Data/Template/CA环境安装包.zip'
      var fileName = 'CA环境安装包'
      var url = 'SupplierLogin/DownloadTemplate?TemplatefilePath=' + templatefilePath + '&FileName=' + fileName
      this.downloadfile(this.baseURL + url)
    }
  }
}
</script>
<style scoped lang="scss">
.currentMenu {
  margin: 16px 5px;
}

.right_content {
  margin: 0 10px;
  height: 93%;
  background: #fff;
}

.title1 {
  padding: 10px 0;
  background-color: #f9f9d2;
  text-align: center;
  color: #ff6600;
  font-size: 16px;
}

.list_wrap1 {
  display: flex;
  flex-wrap: wrap;
  padding: 0 20px;

  .list {
    width: 33%;
    display: flex;
    padding-bottom: 20px;
  }

  .text1 {
    color: #0660a2;
    font-weight: bold;
    white-space: nowrap;
  }
}

.title2 {
  font-size: 18px;
  border-bottom: 1px solid #95c7f0;
  padding-bottom: 7px;
  margin: 7px;
}

.list_wrap2 {
  display: flex;
  margin: 0 7px;

  .list {
    padding: 10px 0;
    border-radius: 6px;
    width: 49%;
    display: flex;
    margin-right: 1%;
    background: #f2f2f2;
    align-items: flex-start;
    justify-content: center;

    .img1 {
      padding-right: 20px;
      border-right: 1px solid #ccc;
      margin-right: 10px;
    }

    .right_text {
      padding-top: 4px;
      flex: 0.4;
      display: flex;

      .text_num {
        color: #f00;
        margin-top: 8px;
        font-size: 26px;
      }

      .text_warning {
        margin-top: 6px;
        white-space: nowrap;
      }

      .text1 {
        margin-right: 26px;
      }

      .text2 {
        margin-top: -6px;
      }

      .btn {
        background: #ff6600;
        color: #fff;
        text-align: center;
        padding: 12px 0;
        border-color: #ff6600;
        border-radius: 6px;
        width: 100px;
      }
    }
  }
}

.el-icon-warning {
  margin-right: 3px;
}

.el-icon-warning:before {
  color: #ff9900;
  font-size: 15px;
}

//重写el_tabs样式
.el_tabs {
  margin: 7px 7px 0;
}

.el_tabs ::v-deep .el-tabs__header {
  float: none;
  margin-right: 0;
  margin-bottom: 0;

  .el-tabs__nav-wrap::after {
    background-color: #95c7f0;
  }

  .el-tabs__item {
    padding: 0 40px;
    color: #054c81;
  }

  .el-tabs__item.is-active {
    color: #fff;
    background: #2db7f5;
  }

  .el-tabs__active-bar {
    display: none;
  }
}

//重写el-table样式
.el_table {
  width: 100%;
  margin: 0 auto;
  border: none;
}

.el_table ::v-deep .el-table__header {
  th {
    background: #f2f2f2;
    text-align: center;
    border-bottom: 2px solid #e4e4e4;
    color: #333;
  }
}

.el_table ::v-deep .el-table__body-wrapper {
  tr {
    background-color: #e6f6fb;
  }

  td {
    text-align: center;
    border-bottom: 1px solid #e4e4e4;
    border-right: none;
    background-color: #fff;
  }
}

.main_content {
  display: flex;
}

.left_Wrap {
  background: #abc9e1;
  min-width: 300px;
}

.right_Wrap {
  flex: 1;
}

.el_tabs2 ::v-deep .el-tabs__header {
  float: none;
  margin-right: 0;

  .el-tabs__item {
    height: auto !important;
    line-height: normal !important;
    border-bottom: 1px solid #fff;
    background: #e4e4e4;
    padding: 0 5px 0 0 !important;
    color: #333;

    .list_content {
      display: flex;
      flex-wrap: wrap;

      .tip {
        // background: #2D76AB;
        background: #acacac;
        color: #fff;
        padding: 0 6px;
        display: flex;
        align-items: center;
      }

      .inforight {
        flex: 1;
        white-space: normal;
        text-align: left;
        padding: 8px 0 8px 8px;

        .list {
          display: flex;
          padding: 5px 0;

          .text1 {
            white-space: nowrap;
          }
        }
      }
    }
  }

  .el-tabs__item.is-active {
    color: #333;
    background: #cdeaf5;

    .tip {
      background: #2d76ab;
    }
  }

  .el-tabs__active-bar {
    display: none;
  }
}
</style>